import { frontendURL } from 'dashboard/helper/URLHelper.js';
import FlowinAppFrame from './FlowinAppFrame.vue';

const meta = { permissions: ['administrator', 'agent', 'custom_role'] };

const flowinAppsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/flowin-apps/pipeline'),
      name: 'custom_pipeline',
      meta,
      component: FlowinAppFrame,
      props: { appUrl: 'https://pipeline.flowincrm.ar' },
    },
    {
      path: frontendURL('accounts/:accountId/flowin-apps/campanas'),
      name: 'custom_campanas',
      meta,
      component: FlowinAppFrame,
      props: { appUrl: 'https://campanas.flowincrm.ar' },
    },
    {
      path: frontendURL('accounts/:accountId/flowin-apps/presupuestos'),
      name: 'custom_presupuestos',
      meta,
      component: FlowinAppFrame,
      props: { appUrl: 'https://presupuestos.flowincrm.ar' },
    },
  ],
};

export default flowinAppsRoutes;
